import { useEffect, useRef, useId, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import EditorCard from './EditorCard';

export default function AppModal({ open, onClose, title, children, footer }: {
  open: boolean; onClose: () => void; title: ReactNode; children: ReactNode; footer?: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    const dialog = ref.current;
    dialog?.showModal();
    return () => { dialog?.close(); previous?.focus(); };
  }, [open]);
  if (!open) return null;
  return createPortal(<dialog ref={ref} aria-labelledby={titleId}
    className="m-auto w-[calc(100%_-_2rem)] max-w-2xl overflow-visible bg-transparent p-0 text-inherit backdrop:bg-black/60 backdrop:backdrop-blur-sm"
    onCancel={e => { e.preventDefault(); onClose(); }}
    onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
    <EditorCard title={<span id={titleId}>{title}</span>} onClose={onClose} closeLabel="Cerrar" footer={footer}>
      {children}
    </EditorCard>
  </dialog>, document.body);
}
